import { render } from "./TeamTile-v2.vue?vue&type=template&id=f969b88c"
import script from "./TeamTile-v2.vue?vue&type=script&lang=js"
export * from "./TeamTile-v2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__